// IDenormalizedReviewQuestion
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReportingReviewQuestionDocument", {
    enumerable: true,
    get: function() {
        return ReportingReviewQuestionDocument;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _user = require("../user");
const ReportingReviewQuestionDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    answer: _zod.z.any(),
    question: _zod.z.string(),
    subtext: _zod.z.string().nullable(),
    type: _zod.z.string(),
    hash: _zod.z.string(),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    subjectID: _zod.z.instanceof(_bson.ObjectId),
    authors: _zod.z.array(_user.SkinnyEmployee),
    signers: _zod.z.array(_user.SkinnyEmployee),
    review_report_id: _zod.z.instanceof(_bson.ObjectId),
    review: _zod.z.object({
        id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string()
    })
});
